import PageHead from "@/components/seo/PageHead";
import "@/i18n/config";
import { NextPage } from "next";
import type { AppProps } from "next/app";
import Head from "next/head";
import "quill/dist/quill.bubble.css";
import "quill/dist/quill.snow.css";
import { ReactElement, ReactNode } from "react";
import "./app.css";
import "./index.css";

export type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
  getLayout?: (page: ReactElement) => ReactNode;
};

type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout;
};

export default function BaseApp({ Component, pageProps }: AppPropsWithLayout) {
  const getLayout = Component.getLayout ?? ((page) => page);
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>
      <PageHead namespace="common" titleKey="siteName" descriptionKey="siteDescription" />
      {getLayout(<Component {...pageProps} />)}
    </>
  );
}
